// @flow
import React, { Component } from 'react';
import AgeRangeReaches from 'common/domain/AgeRangeReaches';
import GenderReach from 'common/domain/GenderReach';
import CampaignPrinting from 'common/modules/campaign/components/printing/CampaignPrinting';
import Campaign from 'common/modules/campaign/domain/Campaign';
import CampaignMetrics from 'common/modules/campaign/domain/CampaignMetrics';
import PrintingService from 'common/services/PrintingService';
import PrintingPage from 'common/components/PrintingPage';

type State = {
  loaded: boolean;
  campaign: ?Campaign;
  metrics: ?CampaignMetrics;
}

class CampaignPrintingPage extends Component<void, State> {
  state = {
    loaded: false,
    campaign: undefined,
    metrics: undefined,
  };

  componentWillMount() {
    const data = PrintingService.getData('CAMPAIGN_PRINTING_DATA');
    if (!data) {
      return;
    }

    const metrics = new CampaignMetrics({
      ...data.metrics,
      ageGroup: AgeRangeReaches.parse(data.metrics.ageGroup),
      genderDimension: GenderReach.parse(data.metrics.genderDimension),
    });

    this.setState({
      loaded: true,
      campaign: Campaign.parse(data.campaign),
      metrics,
    }, () => {
      setTimeout(() => window.print(), 1000);
    });
  }

  render() {
    const { loaded, campaign, metrics } = this.state;
    return (
      <PrintingPage loading={!loaded}>
        {campaign && metrics &&
          <CampaignPrinting
            metrics={metrics}
            campaign={campaign}
          />
        }
      </PrintingPage>
    );
  }
}

export default CampaignPrintingPage;



// WEBPACK FOOTER //
// ./src/statsradio/modules/campaigns/printing/CampaignPrintingPage.js